export const TAG_LOG = 'LOG'
export const TAG_LOGS = 'LOGS'

export default [TAG_LOG, TAG_LOGS]
